import groq from "groq"

export const tourPLanningProjection = () => groq`
  id,
  tour01,
  tour02,
  tour03,
  tour04,
  tour05,
  tour06,
  tour07,
  tour08,
`

export const agreedTourProjection = () => groq`
"id": _id,
customerNumber,
calendarWeek,
year,
admNumber,
creationAt,
creationBy,
`
